export const CHAT_CONTINUATION_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1_000

export type ChatContinuationEligibility = 'eligible' | 'history-only' | 'invalid'

export function getChatContinuationEligibility(
  createdAt: string | undefined,
  now = Date.now(),
): ChatContinuationEligibility {
  if (!createdAt) return 'invalid'
  const createdAtMs = Date.parse(createdAt)
  if (Number.isNaN(createdAtMs)) return 'invalid'
  return now - createdAtMs > CHAT_CONTINUATION_MAX_AGE_MS ? 'history-only' : 'eligible'
}
